module.exports = __webpack_public_path__ + "static/media/190.03e420f4.mp3";